import { BusinessFactory } from '@/coreDomainsModule/factories/BusinessFactory';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';
import { InventoryAnalyticsDetailAggreageBusiness } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { DetailAggregateBusinessData } from '@/inventoryDashboardModule/pages/useInventoryDashboardStore/types';

/**
 * 在庫管理ダッシュボードの詳細情報(集計)を生成する
 */
export class DetailAggregateBusinessDataFactory {
  /**
   * 在庫管理ダッシュボードの詳細情報(集計)を生成する
   * @param initialData - 初期情報
   */
  public static create = (initialData: Partial<InventoryAnalyticsDetailAggreageBusiness> = {}): DetailAggregateBusinessData => {
    const res: DetailAggregateBusinessData = {
      ...BusinessFactory.create({
        ...initialData,
        businessId: initialData.aggregateBusinessId,
        aggregateBusinessResponsibleUsers: initialData.aggregateBusinessReponsibleUsers?.map((u) =>
          UserAccountFactory.create({ email: u.id, name: u.name })
        ),
      }),
      latestInventoryAmount: initialData.latestInventoryAmount ? Number(initialData.latestInventoryAmount) : undefined,
      lastMonthEndInventoryAmount: initialData.lastMonthEndInventoryAmount ? Number(initialData.lastMonthEndInventoryAmount) : undefined,
      lastMonthSalesResultAmount: initialData.lastMonthSalesResultAmount ? Number(initialData.lastMonthSalesResultAmount) : undefined,
      turnover: initialData.turnover ? Number(initialData.turnover) : undefined,
    };
    return res;
  };
}
